import { Spinner } from "construct-ui";
import rocketChatConfig from "../../config/rocket-chat-variables";
import loginModel from "../../models/login.model";

export default function Messenger() {
  let isLoading = false;

  const getRocketchatInfo = () => {
    return loginModel.loginRocketchat().then((result) => {
      return result;
    }).catch((error) => {
      this.handleError(error);
    })
  }

  const login = async (e) => {
    if (e.origin === rocketChatConfig.API_URL) {
      let iframe = document.getElementById('rc-chat');

      switch (e.data.eventName) {
        case 'Custom_Script_Logged_Out': {
          const info = await getRocketchatInfo();
          if (info) {
            iframe.contentWindow.postMessage({
              URL: rocketChatConfig.API_URL,
              userName: loginModel.credentials.userID,
              email: loginModel.profileDetails.email,
              name: loginModel.profileDetails.userName,
              actVal: 'Login',
              info: info,
            }, rocketChatConfig.API_URL);
          }
          break;
        }
        case 'logged-in':
          if (loginModel.credentials.userID !== e.data.data) {
            iframe.contentWindow.postMessage({
              URL: rocketChatConfig.API_URL,
              actVal: 'Logout'
            }, rocketChatConfig.API_URL)
          }
          break;
        case 'Custom_Script_Logged_In':
          isLoading = false;
          m.redraw()
        default:
          break;
      }
    }
  }

  return {
    oncreate: () => {
      isLoading = true;
      addEventListener('message', login)
    },
    onremove: () => {
      removeEventListener('message', login)
    },
    view: () => {
      return m('.chat-container', {
        style: 'width: 100%; height: calc(100vh - 13.5rem)'
      },
        m('iframe', {
          id: 'rc-chat',
          src: rocketChatConfig.API_URL,
          style: `width: 100%; height: calc(100vh - 13.5rem); opacity:${isLoading ? 0 : 1}`,
        }),
        m(Spinner, {
          active: isLoading,
          background: true,
          fill: true,
          size: 'l',
        })
      )
    }
  }
}